import { useState } from 'react';
import PropTypes from 'prop-types';
import BottomSheet from '../BottomSheet';
import { TextField } from '../FormFields';

const CreateFamilyAccountSheet = ({ onCreate, onClose }) => {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    const trimmedName = name.trim();
    if (!trimmedName) {
      setError('Informe o nome da família.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      await onCreate(trimmedName);
      onClose();
    } catch (createError) {
  if (process.env.NODE_ENV === 'development') {
    console.error('Erro ao criar conta familiar:', {
      code: createError?.code,
      message: createError?.message,
    });
  }

  setError('Não foi possível criar a conta familiar. Tente novamente.');
} finally {
      setSaving(false);
    }
  };

  return (
    <BottomSheet
      title="Criar conta familiar"
      subtitle="Crie um espaço financeiro para organizar a família em conjunto."
      onClose={onClose}
      size="sm"
      footer={<button type="submit" form="create-family-account-form" className="nf-sheet__primary" disabled={saving}>{saving ? 'Criando...' : 'Criar conta familiar'}</button>}
    >
      <form id="create-family-account-form" onSubmit={submit}>
        <TextField id="family-account-name" label="Nome da conta" value={name} onChange={setName} placeholder="Ex.: Nossa família" maxLength={120} required />
        {error && <p className="nf-sheet-copy-status" role="alert">{error}</p>}
      </form>
    </BottomSheet>
  );
};

CreateFamilyAccountSheet.propTypes = { onCreate: PropTypes.func.isRequired, onClose: PropTypes.func.isRequired };
export default CreateFamilyAccountSheet;